<template>
  <div class="stok" :class="{ 'animate-flicker': loading }">
    <div>
      <h2><back @click="$router.go(-1)" />History Stok {{ barang }}</h2>

      <br />

      <div class="body">
        <ul>
          <li v-for="(i, key) in data" :key="key">
            <h3>{{ moment(key).format("DD MMM YYYY") }}</h3>
            <table v-for="(item, index) in i" :key="index">
              <tr>
                <td>
                  <span v-show="item.tipe == 'STOK_MASUK'">Stok Masuk</span>
                  <span v-show="item.tipe == 'STOK_KELUAR'" class="stok-keluar"
                    >Stok Keluar</span
                  >
                  <span v-show="item.tipe == 'PENYESUAIAN'" class="penyesuaian"
                    >Penyesuaian Stok</span
                  >
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr v-show="item.tipe != 'PENYESUAIAN'">
                <td>No Nota</td>
                <td>:</td>
                <td>{{ item.no_nota }}</td>
              </tr>
              <tr>
                <td>
                  {{
                    item.tipe == "PENYESUAIAN"
                      ? "Jumlah penyesuaian"
                      : "Jumlah digunakan"
                  }}
                </td>
                <td>:</td>
                <td>{{ item.jumlah | decimal }} {{ item.satuan }}</td>
              </tr>
            </table>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Back from "../icons/Back.vue";

import * as api from "../../api/Api";
import moment from "moment";
import _ from "lodash";

export default {
  name: "BahanBaku",
  components: {
    Back,
  },
  data() {
    return {
      loading: false,
      data: [],
      barang: "",
    };
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;
      api
        .get("/v4/stok/history?id_barang=" + this.$route.params.id)
        .then((r) => {
          this.loading = false;
          this.data = _.groupBy(r.data, "tanggal");

          this.barang = r.data[0].nama;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.stok {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    svg {
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .body {
    h3 {
      margin-top: 0;
      margin-bottom: 10px;
    }
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      li {
        padding: 15px;
        width: auto;
        border-radius: 5px;
      }
    }
    table {
      border-collapse: collapse;
      margin-left: 15px;
      margin-bottom: 20px;
      td {
        padding: 5px 0;
        font-size: 14px;
        &:nth-child(1) {
          padding-right: 10px;
          width: 160px;
        }
        &:nth-child(2) {
          width: 10px;
        }

        span {
          font-size: 12px;
          background-color: var(--green);
          color: #fff;
          padding: 4px 8px;
          border-radius: 4px;
          &.stok-keluar {
            background-color: var(--red);
          }
          &.penyesuaian {
            background-color: var(--orange);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/stok/DetailStok.vue